'use client';

import { c as _c } from "react/compiler-runtime";
import { Xmark } from '@byway/icons';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { Dialog, Modal, ModalOverlay } from 'react-aria-components';
import { Button } from '~/components/Button';
import styles from './AccountPanel.module.css';
type AccountPanelProps = {
  readonly ariaLabel: string;
  readonly children: ReactNode;
  readonly close: () => void;
  readonly isOpen: boolean;
};
export const AccountPanel = t0 => {
  const $ = _c(14);
  const {
    ariaLabel,
    children,
    close,
    isOpen
  } = t0;
  const t = useTranslations("aria");
  let t1;
  if ($[0] !== t) {
    t1 = t("close");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Xmark decorative={true} size="large" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== close || $[4] !== t1) {
    t3 = <div className={styles.header}><Button variant="icon" ariaLabel={t1} onPress={close} dataTestId="account-panel-close">{t2}</Button></div>;
    $[3] = close;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== ariaLabel || $[7] !== children || $[8] !== t3) {
    t4 = <Modal className={styles.panel}><Dialog className={styles.dialog} aria-label={ariaLabel} data-test-id="account-panel">{t3}{children}</Dialog></Modal>;
    $[6] = ariaLabel;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== close || $[11] !== isOpen || $[12] !== t4) {
    t5 = <ModalOverlay className={styles.overlay} isDismissable={true} isOpen={isOpen} onOpenChange={close}>{t4}</ModalOverlay>;
    $[10] = close;
    $[11] = isOpen;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};